import React from 'react';
import { Mail, TrendingUp, Users, Target, Rocket } from 'lucide-react';
import Button from '../components/Button';
import SEO from '../components/SEO';

const SponsorPage = () => {
  return (
    <div className="min-h-screen bg-brand-bg">
      <SEO 
        title="Sponsor & Advertise" 
        description="Connect your brand with the next generation of professionals. Reach high-intent teens exploring future career paths."
      />

      <div className="max-w-4xl mx-auto px-4 py-20">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-brand-white mb-6">
            Partner with <span className="text-brand-cyan">FuturePath</span>
          </h1>
          <p className="text-xl text-brand-grey2 max-w-2xl mx-auto">
            Help us bridge the gap between education and high-demand careers while reaching a curious, future-focused audience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-brand-dark border border-brand-border p-8 rounded-2xl text-center">
            <Users className="w-10 h-10 text-brand-cyan mx-auto mb-4" />
            <p className="text-3xl font-bold text-brand-white mb-2">50k+</p>
            <p className="text-brand-grey2 text-sm uppercase tracking-widest font-bold">Monthly Views</p>
          </div>
          <div className="bg-brand-dark border border-brand-border p-8 rounded-2xl text-center">
            <Target className="w-10 h-10 text-brand-green mx-auto mb-4" />
            <p className="text-3xl font-bold text-brand-white mb-2">Teens</p>
            <p className="text-brand-grey2 text-sm uppercase tracking-widest font-bold">Core Audience</p>
          </div>
          <div className="bg-brand-dark border border-brand-border p-8 rounded-2xl text-center">
            <TrendingUp className="w-10 h-10 text-purple-400 mx-auto mb-4" />
            <p className="text-3xl font-bold text-brand-white mb-2">15%</p>
            <p className="text-brand-grey2 text-sm uppercase tracking-widest font-bold">MoM Growth</p>
          </div>
        </div>

        <div className="space-y-12 mb-20">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-grow">
              <h2 className="text-2xl font-heading font-bold text-brand-white mb-4">Ad Readiness</h2>
              <p className="text-brand-grey2 leading-relaxed">
                We are currently building out our sponsorship packages. From video placement in our Shorts feed to featured tool slots in career guides, we offer non-invasive, high-value visibility.
              </p>
            </div>
            <div className="w-full md:w-64 h-40 rounded-2xl bg-brand-light border border-brand-border flex items-center justify-center">
              <Rocket className="w-12 h-12 text-brand-cyan/20" />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-tr from-brand-cyan/10 to-brand-green/10 border border-brand-border rounded-3xl p-10 text-center">
          <h2 className="text-3xl font-heading font-bold text-brand-white mb-4">Request Media Kit</h2>
          <p className="text-brand-grey2 mb-8 max-w-md mx-auto">
            Ready to reach the next generation? Email our partnership team for a breakdown of our demographics and packages.
          </p>
          <a href="mailto:partners@futurepathteens.com">
            <Button size="lg" className="shadow-lg shadow-brand-cyan/20">
              <Mail className="w-5 h-5 mr-2" />
              Email Partnership Team
            </Button>
          </a>
          <p className="text-xs text-brand-grey2 mt-6">
            Response time: Usually within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SponsorPage;
